/**
 * 通过值找label
 * @param {Array} data 数据集合
 * @param {Array} keys 节点的key集合
 * @param {String} idKey 指定key对应的字段
 */
export const getNodesByKey = (propData, keys, idKey) => {
  let nodes: any[] = []
  const f = (data): any => {
    data.forEach((item) => {
      if (keys.includes(item[idKey])) {
        nodes.push(item)
      }
      if (item.children?.length > 0) {
        f(item.children)
      }
    })
    return nodes
  }
  return f(propData)
}
